export default "__VITE_ASSET__ZWwOMDQ8__"